module.exports = __webpack_public_path__ + "static/phisics-5c0ec6fed19d71e6d184c8f514a7f820.gif";